<div
  data-at-info-panel
  class="vi-info-panel flex flex-row lt-md:flex-col gap-[34px] lt-md:gap-[15px] justify-start items-start"
>
  <div data-at-image class="image lt-md:flex-auto flex-[245px] max-w-[245px]">
    <img [src]="imageSrc" />
  </div>
  <div
    data-at-content
    class="content flex flex-row flex-wrap gap-[10px] justify-between items-start flex-[calc(100% - 265px)] max-w-[calc(100% - 265px)] w-full min-w-full h-full min-h-full"
  >
    <ng-content select="[content]"></ng-content>
  </div>
</div>
